<script>
export default {
    beforeMount(){
        swal("멤버십 가입을 축하합니다.", {
            icon: "success",
        }).then(() => {
            this.$router.push('/main/pc4?tab=membership')
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/NaverSuccess.vue